import { AngularEditorConfig } from '@kolkov/angular-editor';

const editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    placeholder: 'Enter your content here...',
    toolbarPosition: 'top',
    enableToolbar: true,
    showToolbar: true,
    toolbarHiddenButtons: [
      ['strikeThrough','superscript', 'subscript', 'insertImage', 'insertVideo', 'unlink', 'removeFormat', 'toggleEditorMode','insertHorizontalRule','insertLink']
    ],
    defaultFontSize: '3',
    sanitize: false // <-- เปลี่ยนเป็น false เพื่ออนุญาต inline style
  };
  
export function getEditorConfig(): AngularEditorConfig {
    return editorConfig;
}